module.exports = function() {
  return new Worker(__webpack_public_path__ + "75c18ae1f7ca674767f5.worker.js");
};